import $ from 'jquery';
import 'slick-carousel';
if (window.matchMedia('(max-width: 1024px)').matches) {
    $(".top__level").click(function () {
        $(".first-level", this).slideToggle('fast');
        $(this).toggleClass('menu-open');
    });
}
$(".menu__toggle").click(function () {
    $(".menu__toggle").toggleClass("menu-open");
    $(".nav__mobile").slideToggle('fast');
});
$('.logo__slider').slick({
    infinite: true,
    autoplay: true,
    arrows: false,
    mobileFirst: true,
    autoplaySpeed: 2000,
    responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 320,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
}); // auto update cart ammount
var timeout;
$('.woocommerce').on('change', 'input.qty', function () {
    if (timeout !== undefined) {
        clearTimeout(timeout);
    }
    timeout = setTimeout(function () {
        $("[name='update_cart']").trigger("click");
    }, 500); // 1 second delay, half a second (500) seems comfortable too
});
